import { Link } from 'react-router-dom';
import Icon from '../Icon/Icon';

const ModalError = ({ text, closeModal }: { text: string; closeModal: () => void }) => (
  <div className="modal-content">
    <span className="modal-status-icon modal-status-icon--error"><Icon name="alert" /></span>
    <h1 id="modal-title" className="modal-title">Algo salió mal</h1>
    <p className="modal-text">{text || 'En este momento el servicio no está disponible. Inténtalo nuevamente más tarde.'}</p>
    <div className="modal-actions">
      <button type="button" className="lis-button lis-button--primary" onClick={closeModal}><Icon name="refresh" className="lis-inline-icon" />Intentar de nuevo</button>
      <Link to="/" className="lis-button lis-button--secondary" onClick={closeModal}>Volver</Link>
    </div>
  </div>
);

export default ModalError;
